export function getGoogleAnalyticsMeasurementId(): string | null {
  const measurementId = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim() || "";

  return measurementId || null;
}

export function getGoogleAdsConversionId(): string | null {
  const conversionId =
    process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_ID?.trim() || "";

  return conversionId || null;
}

export function getRuntimeGoogleAdsConversionId(): string | null {
  const conversionId =
    process.env.GOOGLE_ADS_CONVERSION_ID?.trim() ||
    process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_ID?.trim() ||
    "";

  return conversionId || null;
}

export function getGoogleAdsPurchaseConversionLabel(): string | null {
  const conversionLabel =
    process.env.NEXT_PUBLIC_GOOGLE_ADS_PURCHASE_CONVERSION_LABEL?.trim() || "";

  return conversionLabel || null;
}

export function getRuntimeGoogleAdsPurchaseConversionLabel(): string | null {
  const conversionLabel =
    process.env.GOOGLE_ADS_PURCHASE_CONVERSION_LABEL?.trim() ||
    process.env.NEXT_PUBLIC_GOOGLE_ADS_PURCHASE_CONVERSION_LABEL?.trim() ||
    "";

  return conversionLabel || null;
}

export function getClarityProjectId(): string | null {
  const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim() || "";

  return projectId || null;
}
